
angular.module('bmsApp.license', []);
angular.module('bmsApp.marketing').factory('LicenseOptionsSvc', function ($http, $log, $window, $q, CRUDSvc, LICENSE_API) {

	return {
		license: function (params) {
			return CRUDSvc.get(LICENSE_API.INDEX, params);
		},

		network: function(params) {
			return CRUDSvc.get(LICENSE_API.NETWORK_INDEX, params);
		},

		notification: function () {
			return CRUDSvc.get(LICENSE_API.NOTIFICATION);
		}
	}



}).constant('LICENSE_API', {
	INDEX: 'api/license/options',
	NETWORK_INDEX: 'api/license/type/options',
	NOTIFICATION: 'api/license/notification/read',
});